import styled from 'styled-components';

export const Slide = styled.div<{gap?: number}>`
  display: flex;
  flex-direction: column;
  margin-right: 16px;
  gap: ${({gap}) => gap ?? 32}px;
  width: 100%;
`;
